import { render, staticRenderFns } from "./IntroModal.vue?vue&type=template&id=35df517e&scoped=true"
import script from "./IntroModal.vue?vue&type=script&lang=js"
export * from "./IntroModal.vue?vue&type=script&lang=js"
import style0 from "./IntroModal.vue?vue&type=style&index=0&id=35df517e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35df517e",
  null
  
)

export default component.exports